<template>
   <div>
    <nav class="menu-des-footer">
        <h6 class="  title">
            {{ title }}
        </h6>
        <ul class="d-flex flex-column " >
            <li v-for="(item , index) in list" :key="index">
                <DynamicLinker class="link-menu-footer" :item="item">{{ item.title }}</DynamicLinker>
                <!-- <a href="/">{{item.title}}</a> -->
            </li>
        </ul>
    </nav>
    <details class="menu-res-footer">
        <summary>
            <h6 class="  title">
                {{ title }}
            </h6>
        </summary>
        <nav class="pr-3">
            
            <ul class="d-flex flex-column " >
                <li v-for="(item , index) in list" :key="index">
                    <DynamicLinker class="link-menu-footer" :item="item">{{ item.title }}</DynamicLinker>
                    <!-- <a href="/">{{item.title}}</a> -->
                </li>
            </ul>
        </nav>
    </details>
   </div>
  
    
</template>
<script>
import DynamicLinker from "@/parts/Front/components/shared/DynamicLinker";

export default {
    name:"menu-footer",
    components:{DynamicLinker},
    props:{
        list:Array,
        title:{
            type:String,
            default:""
        }

    }
}
</script>
<style scoped>
.menu-res-footer{
    display: none;
    position: relative;
}
.menu-res-footer summary::marker{
    content: "";
}
.menu-res-footer summary::after{
    content: "+";
    position: absolute;
    left: 0;
    top: 0;
    font-weight: 800;
    font-size: 18px;
    -webkit-text-stroke-width: 1px;
}
.menu-res-footer[open] summary::after{
    content: "-";

}
@media screen and (max-width:768px) {
    .menu-des-footer{
        display: none;
    }
    .menu-res-footer{
        display: block;
    }
  }

ul{
    list-style-type: none;
    gap: 10px;
}
a{
    color: #797979;
}
.title{
    font-size: 16px;
    font-weight: 900;
    margin-bottom: 20px;
    color: var(--pink-theme2);

}
.link-menu-footer{
    transition: all .4s;
    color: #000;
}
.link-menu-footer:hover{
    color: var(--pink-theme2);
    letter-spacing: 1.2px;
}
</style>